module.exports = __webpack_public_path__ + "static/lunchtype22-regular-webfont-6a029ddee534b2b77169a6bce5d028fb.woff2";